import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getReferalDetails, UserReferalDetailsResponse } from "../../Admin-Api/GetReferalDetailsAsync";
import { toast } from "react-toastify";

const ReferralEachUser: React.FC = () => {

    const { userId } = useParams<{ userId: string }>();
    const navigate = useNavigate();

    const [data, setData] = useState<UserReferalDetailsResponse | null>(null);
    const [loading, setLoading] = useState(true);

    const fetchReferralDetails = async () => {
        try {

            if (!userId) return;

            const response = await getReferalDetails(
                Number(userId),
                (key) => key
            );

            setData(response);

        } catch (error) {
            toast.error("Failed to load referral details");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userId) {
            fetchReferralDetails();
        }
    }, [userId]);

    return (
        <div className="min-h-screen bg-gray-50 p-6">

            <div className="max-w-5xl mx-auto">

                {/* Header */}

                <div className="flex justify-between items-center mb-6">

                    <h1 className="text-2xl font-bold text-gray-800">
                        Referral Details
                    </h1>

                    <button
                        onClick={() => navigate(-1)}
                        className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                    >
                        Back
                    </button>

                </div>

                {loading ? (
                    <p className="text-center text-gray-500">Loading...</p>
                ) : data ? (

                    <div className="bg-white rounded-xl shadow-md p-6">

                        {/* Summary */}

                        <div className="grid grid-cols-3 gap-6 mb-8">

                            <div className="bg-indigo-50 p-4 rounded-lg">
                                <p className="text-sm text-gray-500">User ID</p>
                                <p className="text-lg font-semibold">{data.userId}</p>
                            </div>

                            <div className="bg-indigo-50 p-4 rounded-lg">
                                <p className="text-sm text-gray-500">Referred By</p>
                                <p className="text-lg font-semibold">
                                    {data.referredBy || "Normal User"}
                                </p>
                            </div>

                            <div className="bg-indigo-50 p-4 rounded-lg">
                                <p className="text-sm text-gray-500">Referral Count</p>
                                <p className="text-lg font-semibold text-indigo-600">
                                    {data.referralCount}
                                </p>
                            </div>

                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">

                            {data.referrals.map((ref, index) => (

                                <div
                                    key={ref.id}
                                    className="border rounded-lg p-4 shadow-sm hover:shadow-md transition bg-gray-50"
                                >

                                    <div className="flex justify-between items-center mb-2">

                                        <h2 className="font-semibold text-gray-700">
                                            #{index + 1} {ref.userName}
                                        </h2>

                                        <span className={`px-3 py-1 rounded text-xs font-medium
                    ${ref.status
                                                ? "bg-green-100 text-green-700"
                                                : "bg-red-100 text-red-700"
                                            }`}>
                                            {ref.status ? "Active" : "Inactive"}
                                        </span>

                                    </div>

                                    <div className="space-y-2 text-sm text-gray-600">

                                        <div>
                                            <span className="font-medium text-gray-500">Email:</span>
                                            <div>{ref.email}</div>
                                        </div>

                                        <div>
                                            <span className="font-medium text-gray-500">Phone:</span>
                                            <div>{ref.phoneNumber}</div>
                                        </div>

                                    </div>

                                </div>

                            ))}

                        </div>
                    </div>

                ) : (
                    <p className="text-center text-gray-500">No data found</p>
                )}

            </div>

        </div>
    );
};

export default ReferralEachUser;